"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenerateMixedVoiceoverRequestToJSON = exports.GenerateMixedVoiceoverRequestFromJSONTyped = exports.GenerateMixedVoiceoverRequestFromJSON = exports.instanceOfGenerateMixedVoiceoverRequest = void 0;
var VoiceoverTone_1 = require("./VoiceoverTone");
/**
 * Check if a given object implements the GenerateMixedVoiceoverRequest interface.
 */
function instanceOfGenerateMixedVoiceoverRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "brandName" in value;
    isInstance = isInstance && "talkingPoints" in value;
    isInstance = isInstance && "aiVoiceoverTone" in value;
    isInstance = isInstance && "voiceProfileId" in value;
    isInstance = isInstance && "backgroundId" in value;
    return isInstance;
}
exports.instanceOfGenerateMixedVoiceoverRequest = instanceOfGenerateMixedVoiceoverRequest;
function GenerateMixedVoiceoverRequestFromJSON(json) {
    return GenerateMixedVoiceoverRequestFromJSONTyped(json, false);
}
exports.GenerateMixedVoiceoverRequestFromJSON = GenerateMixedVoiceoverRequestFromJSON;
function GenerateMixedVoiceoverRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'brandName': json['brand_name'],
        'talkingPoints': json['talking_points'],
        'aiVoiceoverTone': (0, VoiceoverTone_1.VoiceoverToneFromJSON)(json['ai_voiceover_tone']),
        'voiceProfileId': json['voice_profile_id'],
        'backgroundId': json['background_id'],
    };
}
exports.GenerateMixedVoiceoverRequestFromJSONTyped = GenerateMixedVoiceoverRequestFromJSONTyped;
function GenerateMixedVoiceoverRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'brand_name': value.brandName,
        'talking_points': value.talkingPoints,
        'ai_voiceover_tone': (0, VoiceoverTone_1.VoiceoverToneToJSON)(value.aiVoiceoverTone),
        'voice_profile_id': value.voiceProfileId,
        'background_id': value.backgroundId,
    };
}
exports.GenerateMixedVoiceoverRequestToJSON = GenerateMixedVoiceoverRequestToJSON;
